import React, { FC, useCallback, useEffect, useState } from 'react';

import { EvTitle } from '@evinced-private/ui-common';

import { SCREENSHOT_BLOCK_DAID } from 'data-automation-ids/data-automation-ids';
import { getBoundingBoxStyles } from 'src/common/components/mobile-component-details-block/MobileComponentDetailsBlockHelper';
import { NumberedBadge } from 'src/common/components/numbered-badge/NumberedBadge';
import { Logger } from 'src/common/services/Logger';
import { screenshotService } from 'src/common/services/ScreenshotService';
import { MobileScreenshotDetails } from 'src/common/types/MobileSingleSessionTypes';

import './MobileScreenshotBlock.scss';

interface IMobileScreenshotBlockProps {
	screenshotDetails: MobileScreenshotDetails;
	runTime: string;
	scanName: string;
	issueNumber: string;
}

const IMAGE_CONTAINER_WIDTH = 270;

export const MobileScreenshotBlock: FC<IMobileScreenshotBlockProps> = ({
	screenshotDetails,
	runTime,
	issueNumber,
	scanName
}) => {
	const [image, setImage] = useState<string>(null);

	const imageScale = IMAGE_CONTAINER_WIDTH / screenshotDetails.viewportWidth;

	const resolveImage = useCallback((screenshotDescriptor: MobileScreenshotDetails) => {
		try {
			const screenshotImageData = screenshotService.getFullPageScreenshot(
				screenshotDescriptor.pageScreenshotUrl
			);
			setImage(screenshotImageData);
		} catch (e) {
			Logger.warn('Screenshot could not be loaded', e);
			setImage(null);
		}
	}, []);

	useEffect(() => {
		if (!image && screenshotDetails) {
			resolveImage(screenshotDetails);
		}
	}, [screenshotDetails, image, resolveImage]);

	if (!image) {
		return null;
	}

	return (
		<div className="screenshot-block" data-automation-id={SCREENSHOT_BLOCK_DAID}>
			<EvTitle headingLevel={3} className="scan-name" titleText={scanName} />
			<div className="screenshot">
				<img src={image} alt="Issue Screenshot" className="screenshot-image" />
				<div
					className="bounding-box"
					style={getBoundingBoxStyles(screenshotDetails.boundingBox, imageScale)}
					aria-hidden={true}
				>
					<NumberedBadge number={issueNumber} />
				</div>
			</div>
			<div className="run-time">{runTime}</div>
		</div>
	);
};
